import { TextField, TextFieldProps } from '@mui/material'
import { forwardRef } from 'react'
import { IMaskInput } from 'react-imask'

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
  mask: string
}

const MaskInputComponent = forwardRef<HTMLInputElement, CustomProps>(
  function MaskInputComponent(props, ref) {
    const { onChange, mask, ...other } = props
    return (
      <IMaskInput
        {...other}
        mask={mask}
        inputRef={ref}
        onAccept={(_: any, mask: any) =>
          onChange({ target: { name: props.name, value: mask.unmaskedValue } })
        }
        overwrite
      />
    )
  },
)

type MaskedInputProps = {
  mask: string
} & TextFieldProps

const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>((props, ref) => {
  const { mask, ...textFieldProps } = props

  return (
    <TextField
      {...textFieldProps}
      slotProps={{
        input: {
          ...textFieldProps.InputProps,
          inputComponent: MaskInputComponent as any,
          inputProps: {
            ...textFieldProps.inputProps,
            mask,
          },
        },
      }}
      ref={ref}
    />
  )
})

MaskedInput.displayName = 'MaskedInput'

export default MaskedInput
